import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Reusable Game Session Countdown Timer Component
 *
 * Displays remaining session time (MM:SS) in a sleek top-center glassmorphic pill badge
 * with automatic warning state styling when under 5 minutes.
 */
const SessionTimer = ({ remainingSeconds, totalMinutes, className = "" }) => {
    const minsRemaining =
        remainingSeconds !== undefined
            ? Math.floor(remainingSeconds / 60)
            : totalMinutes || 0;
    const secsRemaining =
        remainingSeconds !== undefined ? remainingSeconds % 60 : 0;
    const isWarning = remainingSeconds !== undefined && remainingSeconds <= 300; // Under 5 mins

    return (
        <div
            className={`SessionTimer ${isWarning ? "SessionTimer--warning" : ""} ${className}`}
            role="timer"
            aria-live="polite"
        >
            <FontAwesomeIcon icon="clock" className="SessionTimer__icon" />
            <span className="SessionTimer__time">
                {minsRemaining}:{String(secsRemaining).padStart(2, "0")}
            </span>
            <span className="SessionTimer__label">
                {minsRemaining > 0 ? "min remaining" : "sec remaining"}
            </span>
        </div>
    );
};

SessionTimer.propTypes = {
    remainingSeconds: PropTypes.number,
    totalMinutes: PropTypes.number,
    className: PropTypes.string,
};

export default SessionTimer;
